import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "i18n";
import { PERIOD_TYPES } from "Config";
import { ICONS } from "../Common/Icons";
import PageHeader from "../Common/PageHeader/PageHeader";

import {
  setStatisticsTaskCategorySelected,
  setYearSelectedItem
} from "Actions";
import { fetchTaskTypeItems, fetchTaskTypeStatistics } from "Thunks";

import styles from "./CategoryStatistics.local.scss";
import TaskTypeFilter from "../TaskTypeFilter/TaskTypeFilter";
import { StandardLineChart } from "../Common/Charts/StandardLineChart";
import CheckBoxBtn from "../Common/Checkbox/CheckBoxBtn";

class CategoryStatistics extends PureComponent {
  //******************   Content Functions  **************//

  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      filterFormIsVisible: false,
      yearDivIsVisible: false,
      expandedType: null,
      period: "QUARTERLY",
      loading: false
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideCategorySelect.bind(this)
    );
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearsSelect.bind(this)
    );
  }
  // //******************   Content Functions END  **************//

  // Task type items functions
  renderTaskTypeList = () => {
    const { types, statistics, fetchingStatistics, selectedYears } = this.props;
    let { expandedType, period } = this.state;
    return (
      <div className={styles.list_items}>
        {types.map((type, i) => {
          return (
            <div key={type.id} className={styles.item}>
              <div
                className={
                  styles.item_header +
                  " " +
                  (expandedType === type.id
                    ? styles.item_header_down
                    : styles.item_header_up)
                }
              >
                <div className={styles.title}>{type.label}</div>
                <div className={styles.actions}>
                  {expandedType === type.id && this.renderYearsSelect(type.id)}
                  <span
                    className={styles.action}
                    onClick={() => this.handleCollapseTypeFrame(type.id)}
                  >
                    {expandedType === type.id ? (
                      <i className="icon icon-arrow-up" />
                    ) : (
                      <i className="icon icon-arrow-down" />
                    )}
                  </span>
                </div>
              </div>
              {expandedType === type.id && (
                <div className={styles.item_body}>
                  {fetchingStatistics ? (
                    <div className={styles.ripple_loading}>
                      <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                    </div>
                  ) : (
                    <div className={styles.item_body_content}>
                      <div className={styles.item_body_content_table}>
                        <table>
                          <thead key={"thead"}>
                            <tr>
                              <th>
                                {_("collaborators")} ({
                                  statistics.collaborators.length
                                })
                              </th>
                              <th>{_("attribution")}</th>
                              <th>{_("timeAchieved")}</th>
                            </tr>
                          </thead>
                          <tbody key={"tbody"}>
                            {statistics.collaborators.map((collaborator, i) => {
                              return (
                                <tr
                                  key={collaborator.id}
                                  className={styles.selected_line}
                                >
                                  <td>{collaborator.name}</td>
                                  <td>
                                    <div className={styles.progress_container}>
                                      <div
                                        className={styles.progress_bar}
                                        style={{
                                          width: collaborator.attribution
                                        }}
                                      />
                                    </div>
                                    <span>{collaborator.attribution}</span>
                                  </td>
                                  <td>{collaborator.nbrHours} h</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className={styles.item_body_content_table}>
                        <table>
                          <thead key={"thead"}>
                            <tr>
                              <th>{_("statistics")}</th>
                            </tr>
                          </thead>
                          <tbody key={"tbody"}>
                            <tr>
                              <td>
                                {selectedYears.length === 1 && (
                                  <div className={styles.tab}>
                                    {PERIOD_TYPES.map((type, i) => {
                                      return (
                                        <div
                                          key={i}
                                          className={
                                            styles.tab_badge +
                                            " " +
                                            (period === type
                                              ? styles.tab_badge_active
                                              : "")
                                          }
                                          onClick={() =>
                                            this.handleSelectPeriodType(type)
                                          }
                                        >
                                          {type}
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                                <StandardLineChart
                                  chartData={Object.values(
                                    selectedYears.length > 1
                                      ? statistics.evolution.values["ANNUAL"]
                                          .data
                                      : statistics.evolution.values[period].data
                                  )}
                                  dataKeysY={statistics.evolution.accounts.map(
                                    ({ code }) => code
                                  )}
                                  dataKeyX={
                                    selectedYears.length > 1
                                      ? statistics.evolution.values["ANNUAL"]
                                          .key
                                      : statistics.evolution.values[period].key
                                  }
                                  currency={
                                    statistics.evolution.accounts[0].unit ===
                                    "h"
                                  }
                                  legendLabels={statistics.evolution.accounts.map(
                                    ({ label }) => label
                                  )}
                                  containerHeight={
                                    selectedYears.length === 1 ? 270 : 320
                                  }
                                  tooltipValueFormat={"H"}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  handleCollapseTypeFrame = id => {
    let { expandedType } = this.state;

    if (expandedType === id) {
      this.setState({ expandedType: null });
    } else {
      this.setState({ expandedType: id });
      this.props.dispatch(fetchTaskTypeStatistics(id));
    }
  };

  handleSelectPeriodType = type => {
    this.setState({ period: type });
  };

  renderCategoryByLangage = category => {
    let { lng } = this.props;
    if (category.label[lng]) return category.label[lng];
    if (category.label.en) return category.label.en;
    if (category.label.nl) return category.label.nl;
    if (category.label.fr) return category.label.fr;
  };

  // Categories select filter functions
  renderCategorySelect = () => {
    const { categories, selectedCategory, lng } = this.props;
    const { categoryDivIsVisible } = this.state;

    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.categoryDivIsVisible ? styles.customed_select_opened : "")
        }
      >
        <div className={styles.customed_select_header}>
          <span>{selectedCategory && selectedCategory.label[lng]}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayCategorySelectItems}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {categoryDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {categories.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleSelectCategory(item)}
                >
                  {this.renderCategoryByLangage(item)}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleDisplayCategorySelectItems = () => {
    this.setState(state => {
      return {
        categoryDivIsVisible: !state.categoryDivIsVisible
      };
    });
  };

  handleSelectCategory = category => {
    this.props.dispatch(setStatisticsTaskCategorySelected(category));
    this.props.dispatch(fetchTaskTypeItems());
    this.setState({ categoryDivIsVisible: false });
  };

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutsideCategorySelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ categoryDivIsVisible: false });
    }
  }

  // Years select filter functions
  renderYearsSelect = typeId => {
    const { selectedYears, years } = this.props;
    const { expandedYearsDiv } = this.state;

    return (
      <div
        ref={this.setYearsWrapperRef.bind(this)}
        className={
          styles.check_select +
          " " +
          (this.state.expandedYearsDiv === typeId
            ? styles.check_select_opened
            : "")
        }
      >
        <div className={styles.check_select_header}>
          <span>{this.renderYearsLabel()}</span>
          <div className={styles.year_actions}>
            <div>
              <span
                className={styles.year_action}
                onClick={() => this.handleDisplayYearSelectItems(typeId)}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {expandedYearsDiv === typeId && (
          <div className={styles.check_select_body}>
            <div className={styles.check_select_body_options}>
              {years.map((item, index) => (
                <div key={index} className={styles.check_select_body_option}>
                  <CheckBoxBtn
                    id={item}
                    checked={selectedYears.includes(item)}
                    onChange={() => this.handleDeselectYear(item, typeId)}
                  />
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleDeselectYear = (year, typeId) => {
    let { selectedYears, years, fetchingStatistics } = this.props;

    if (fetchingStatistics) {
      return;
    }

    let newSelectedItems = [...selectedYears];

    if (selectedYears.length > 1) {
      newSelectedItems = [year];
    } else {
      newSelectedItems =
        selectedYears[0] > year
          ? years.slice(
              years.indexOf(year),
              years.indexOf(selectedYears[0]) + 1
            )
          : years.slice(
              years.indexOf(selectedYears[0]),
              years.indexOf(year) + 1
            );
    }

    this.props.dispatch(setYearSelectedItem(newSelectedItems));
    this.props.dispatch(fetchTaskTypeStatistics(typeId));
  };

  handleDisplayYearSelectItems = typeId => {
    let { expandedYearsDiv } = this.state;

    if (expandedYearsDiv === typeId) {
      this.setState({ expandedYearsDiv: null });
    } else {
      this.setState({ expandedYearsDiv: typeId });
    }
  };

  renderYearsLabel = () => {
    let { selectedYears } = this.props;
    return selectedYears.length > 1
      ? selectedYears[0] + "/" + selectedYears[selectedYears.length - 1]
      : selectedYears[0];
  };

  setYearsWrapperRef(node) {
    this.wrapperYearsRef = node;
  }

  handleClickOutsideYearsSelect(event) {
    if (this.wrapperYearsRef && !this.wrapperYearsRef.contains(event.target)) {
      this.setState({ expandedYearsDiv: null });
    }
  }

  render() {
    const { fetching, fetchingCategories, nbResult } = this.props;

    return (
      <div>
        <PageHeader
          header={_("categories")}
          subHeader={_("subTitleCategoryStatistics")}
          icon={ICONS.CATEGORY_STATISTICS_ICON}
        />
        <div className={styles.resizable}>
          <div className="ttp-tab-container">
            {/* {error && this.renderTypeListCallout(error)} */}
            <div>
              <div className="medium-11" style={{ marginLeft: 52 }}>
                <TaskTypeFilter
                  button={false}
                  customAddOn={this.renderCategorySelect()}
                  filterFormIsVisible={true}
                  nbResult={nbResult}
                  label={_("categoryNumber")}
                  marginLeft={"32em"}
                  fetching={fetching}
                />
              </div>
              <div className="rmodal__center">
                {fetching || fetchingCategories ? (
                  <div className={styles.ripple_loading}>
                    <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                  </div>
                ) : (
                  this.renderTaskTypeList()
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.taskTypes.list.fetching,
  fetched: state.taskTypes.list.fetched,
  error: state.taskTypes.list.error,
  types: state.taskTypes.list.items,
  nbResult: state.taskTypes.list.nbResult,
  selected: state.taskTypes.list.selected,
  years: state.statistics.categories.years.items,
  selectedYears: state.statistics.categories.years.selected,
  categories: state.taskTypes.categories.items,
  fetchingCategories: state.taskTypes.categories.fetching,
  selectedCategory: state.statistics.categories.selected,
  statistics: state.statistics.categories.data,
  fetchingStatistics: state.statistics.categories.fetching,
  errorStatistics: state.statistics.categories.error,
  lng: state.params.lng
});

export default connect(mapStateToProps)(CategoryStatistics);



// WEBPACK FOOTER //
// ./src/components/CategoryStatistics/CategoryStatistics.js